// Cookie-consent state shared by the banner, the analytics loader and the
// privacy page. Stored in localStorage: "accepted" | "declined"; absent means
// the visitor hasn't decided yet (banner shows).
//
// The legacy "trapman_cookie_ack" key is deliberately ignored: the old banner
// was informational only ("no analytics"), so it isn't valid consent for the
// analytics we run now.

const STORAGE_KEY = "voleor_cookie_consent";

const listeners = new Set();

export function getConsent() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "accepted" || v === "declined" ? v : null;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    if (value === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, value);
  } catch {}
  listeners.forEach((fn) => fn(value));
}

export function subscribeConsent(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
